module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/065-eritrea-5d4fb8333f3021a83853341714075eae.svg";